import type { CSSProperties } from 'react';

interface AdSlotProps {
  placement: string;
  minHeight?: CSSProperties['minHeight'];
  style?: CSSProperties;
}

const AD_SLOTS_ENABLED = import.meta.env.VITE_APP_AD_SLOTS !== 'false';

export default function AdSlot({ placement, minHeight = 90, style }: AdSlotProps) {
  if (!AD_SLOTS_ENABLED) return null;

  return (
    <aside
      aria-label="Advertisement"
      data-ad-placement={placement}
      style={{
        minHeight,
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid var(--walky-border)',
        borderTop: '3px solid var(--walky-orange)',
        borderRadius: 8,
        background: 'var(--walky-surface)',
        color: 'var(--walky-muted)',
        boxShadow: 'var(--walky-shadow)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0,
        ...style,
      }}
    >
      Banner publicitario
    </aside>
  );
}
